import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, Button, Nav, ListGroup, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useParams } from "react-router-dom";
import Loader from "../../components/Loader";
import EditClientModal from "./EditClientModal";
import DefaultUser from '../../images/default-user.png';
import DefaultEmail from '../../images/default-email.png';
import DefaultCall from '../../images/default-call.png';
import IconWord from "../../images/dashboard/icon-word.png";
import iconAdd from "../../images/Icons-add.png";
import iconEdit from "../../images/Icons-edit_white.png";
import { MdOutlineFileDownload } from "react-icons/md";
import apiConfig from "../../pages/credentials/apiConfig";
import IconExcel from "../../images/dashboard/icon-excel.png";
import IconNoEngagement from "../../images/no-engagements.svg";
import IconDocumentEngagement from "../../images/no-documents.svg";
import IconPdf from "../../images/dashboard/icon-pdf.png";
import axios from "axios";
import './index.scss';

function ClientDetails() {
    const [loading, setLoading] = useState(true);
    const [activeTab, setActiveTab] = useState("overview");
    const [clientData, setClientData] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isChecked, setIsChecked] = useState(false);
    const { id } = useParams();

    const fetchClientData = async () => {
        const authToken = localStorage.getItem("authToken");
        try {
            const response = await axios.get(`${apiConfig.apiBaseURL}/getClientDetailsWithEngagements/${id}`, {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                    'x-api-key': apiConfig['x-api-key'],
                    'Content-Type': 'application/json'
                }
            });

            const client = response.data.data;

            const mappedClient = {
                id: client._id,
                name: client.clientName || "",
                industry: client.industry || "",
                yearEnd: client.updatedAt ? new Date(client.updatedAt).getFullYear() : "",
                summary: client.companySummary?.description || "No company summary provided.",
                companyDoc: client.companySummary?.fileUrl || null,
                contacts: Array.isArray(client.contactInformation)
                    ? client.contactInformation.map(c => ({
                        name: c.name || "",
                        role: c.role || "",
                        email: c.email || "",
                        phone: c.phone || "",
                        primary: c.primary || false,
                    }))
                    : [],
                documents: Array.isArray(client.documentSummaries)
                    ? client.documentSummaries.flatMap((doc) => {
                        const updatedAt = doc.updatedAt ? new Date(doc.updatedAt).toLocaleDateString() : "No date";
                        const boardMeetings = doc.boardMeetingMinutes?.map(file => ({
                            type: "Board Meeting Minutes",
                            fileUrl: file.fileUrl,
                            fileKey: file.fileKey,
                            updatedAt,
                        })) || [];
                        const debtAgreements = doc.debtAgreements?.map(file => ({
                            type: "Debt Agreements",
                            fileUrl: file.fileUrl,
                            fileKey: file.fileKey,
                            updatedAt,
                        })) || [];

                        return [...boardMeetings, ...debtAgreements];
                    })
                    : [],

                engagements: Array.isArray(client.engagements)
                    ? client.engagements.map(e => ({
                        id: e._id,
                        year: e.engagementYear || "",
                        type: e.engagementType || "",
                        startDate: e.startDate ? new Date(e.startDate).toLocaleDateString() : "",
                        endDate: e.endDate ? new Date(e.endDate).toLocaleDateString() : "",
                        updatedAt: e.updatedAt ? new Date(e.endDate).toLocaleDateString() : "",
                        status: e.status === "open" ? "Open" : "Closed",
                        priorYearTrialBalance: e.priorYearTrialBalance || {},
                        currentYearTrialBalance: e.currentYearTrialBalance || {},
                        priorYearFinancials: e.priorYearFinancials || {}
                    }))
                    : [],
                address1: client.address1 || "",
                address2: client.address2 || "",
                city: client.city || "",
                state: client.state || "",
                stateCode: client.stateCode || "",
                zip: client.zipCode || "",
                isActive: client.isActive || false
            };

            setClientData(mappedClient);
        } catch (error) {
            console.error("Error fetching client details:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchClientData();
    }, [id]);

    const handleTabChange = (tab) => {
        setActiveTab(tab);
    };

    const handleAction = () => {
        setIsModalOpen(true);
    };

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
        if (isModalOpen) fetchClientData();
    };

    const handleToggle = (value) => {
        setIsChecked(value);
    };

    const handleEditClient = () => {
        console.log("Edit client clicked");

    };

    const renderOverviewTab = () => (
        <div className="overview-tab mb-5">
            <h5 className="fw-bold mb-2">Key Information</h5>
            <Card className="mb-4">
                <Card.Body className="p-4">
                    <div className="company-summary mb-4">
                        <h6 className="fw-bold">Company Summary</h6>
                        <p className="text-light">{clientData.summary}</p>
                        {clientData.companyDoc && (
                            <div className="d-flex align-items-center">
                                <img src={IconWord} alt="doc" width={30} />
                                <a
                                    href={clientData.companyDoc}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-primary fw-bold ms-2"
                                    style={{ textDecoration: 'underline' }}
                                >
                                    View Document
                                </a>
                            </div>
                        )}
                    </div>
                    <hr />

                    <div className="contacts-section">
                        <h6 className="fw-bold mb-3">Contacts</h6>
                        {clientData.contacts.length > 0 ? (
                            clientData.contacts.map((contact, idx) => (
                                <Row className={` ${idx !== clientData.contacts.length - 1 ? 'border-bottom mb-3' : ''}`} key={idx}>
                                    <Col md={4}>
                                        <div className="contact-info d-flex mb-2 mb-md-0 py-2">
                                            <div className="contact-avatar me-3">
                                                <img src={DefaultUser} alt="user" />
                                            </div>
                                            <div>
                                                <div className="d-flex align-items-center">
                                                    <strong className="text-primary">{contact?.name || "N/A"}</strong>
                                                    {contact.primary && (
                                                        <span className="ms-2 small rounded-pill text-light px-2" style={{ backgroundColor: '#E7EFF8' }}>Primary</span>
                                                    )}
                                                </div>
                                                <div className="text-muted small">{contact.role || "N/A"}</div>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="contact-email d-flex align-items-center mb-2 mb-md-0">
                                            <div className="me-2">
                                                <img src={DefaultEmail} alt="email" />
                                            </div>
                                            <div>
                                                <div className="small fw-bold text-primary">Email</div>
                                                <div className="text-light">{contact.email || "N/A"}</div>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="contact-phone d-flex align-items-center">
                                            <div className="me-2">
                                                <img src={DefaultCall} alt="phone" />
                                            </div>
                                            <div>
                                                <div className="small fw-bold text-primary">Phone</div>
                                                <div className="text-light">{contact.phone || "N/A"}</div>
                                            </div>
                                        </div>
                                    </Col>


                                </Row>
                            ))
                        ) : (
                            <p className="text-muted">No contacts available.</p>
                        )}
                    </div>
                </Card.Body>
            </Card>

            <h5 className="fw-bold mb-3">All Engagements</h5>
            <Row>
                {clientData.engagements.length > 0 ? (
                    clientData.engagements.map((engagement) => (
                        <Col md={6} key={engagement.id}>
                            <ListGroup>
                                <ListGroup.Item className=" rounded-0 py-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div>
                                            <h6 className="mb-1 text-primary fw-bold">{engagement.year} {engagement.type}</h6>
                                            <div className="text-light small">{engagement.startDate} - {engagement.endDate}</div>
                                        </div>
                                        <div>
                                            <span className={`badge ${engagement.status === 'Open' ? 'bg-primary' : 'bg-success'}`}>
                                                {engagement.status}
                                            </span>
                                        </div>
                                    </div>
                                </ListGroup.Item>

                            </ListGroup>
                            {/* <div className="engagement-item p-3 border rounded">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div>
                                                <h6 className="mb-1">{engagement.year} {engagement.type}</h6>
                                                <div className="text-muted small">{engagement.startDate} - {engagement.endDate}</div>
                                            </div>
                                            <div>
                                                <span className={`badge ${engagement.status === 'Open' ? 'bg-primary' : 'bg-success'}`}>
                                                    {engagement.status}
                                                </span>
                                            </div>
                                        </div>
                                    </div> */}
                        </Col>
                    ))
                ) : (
                    <Card className="mx-auto">
                        <Card.Body className="text-center">
                            <img src={IconNoEngagement} alt="icon-no engagement found" style={{ width: '100px' }} />
                            <p className="text-muted ps-3">No engagements found.</p>
                        </Card.Body>
                    </Card>
                )}
            </Row>
        </div>
    );


    const renderDocumentsTab = () => {
        const engagement = clientData?.engagements?.[0];

        if (!engagement) {
            return (

                <div className="documents-tab">
                    <h5 className="fw-bold mb-3">Documents</h5>
                    <Card className="w-auto mx-auto">
                        <Card.Body className="text-center">
                            <img src={IconDocumentEngagement} alt="icon-no engagement found" style={{ width: '100px' }} />
                            <p className="text-muted my-3">No documents available</p>
                        </Card.Body>
                    </Card>

                </div>
            );
        }

        const priorYearFileUrl = engagement?.priorYearTrialBalance?.fileUrl;
        const currentYearFileUrl = engagement?.currentYearTrialBalance?.fileUrl;
        const priorYearFinancialsUrl = engagement?.priorYearFinancials?.fileUrl;
        const engagementType = engagement?.engagementType || "Audit";
        const updatedDate = (engagement?.updatedAt);

        const getFileNameFromUrl = (url) => {
            try {
                return decodeURIComponent(url.split('/').pop());
            } catch (e) {
                return "Unnamed Document";
            }
        };

        const documents = [
            {
                label: getFileNameFromUrl(priorYearFileUrl),
                fileUrl: priorYearFileUrl,
                icon: IconExcel,
                extension: "Excel Document",
            },
            {
                label: getFileNameFromUrl(currentYearFileUrl),
                fileUrl: currentYearFileUrl,
                icon: IconExcel,
                extension: "Excel Document",
            },
            {
                label: getFileNameFromUrl(priorYearFinancialsUrl),
                fileUrl: priorYearFinancialsUrl,
                icon: IconPdf,
                extension: "PDF Document",
            },
        ];

        return (
            <div className="documents-tab">
                <h5 className="fw-bold mb-3">Documents</h5>
                <Row>
                    {documents
                        .filter((doc) => !!doc.fileUrl)
                        .map((doc, idx) => (
                            <Col md={6} key={idx}>
                                <ListGroup>
                                    <ListGroup.Item className=" rounded-0 py-3">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div className="d-flex align-items-center">
                                                <img src={doc.icon} alt="icon" width={30} className="me-2" />
                                                <div>
                                                    <h6 className="mb-1 text-primary fw-bold">{doc.label}</h6>
                                                    <span className="text-muted small">
                                                        {engagement?.year}  {engagementType} - Updated {updatedDate || "No date"}
                                                    </span>
                                                </div>
                                            </div>
                                            <div>
                                                <OverlayTrigger
                                                    placement="top"
                                                    overlay={<Tooltip >Download</Tooltip>}
                                                >
                                                    <Button
                                                        variant="link"
                                                        className="text-primary p-0"
                                                        href={doc.fileUrl}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        <MdOutlineFileDownload className="text-light" size={25} />
                                                    </Button>
                                                </OverlayTrigger>
                                            </div>
                                        </div>
                                    </ListGroup.Item>
                                </ListGroup>
                            </Col>
                        ))}
                    {clientData.documents.length > 0 && (
                        <>
                            <h5 className="fw-bold mb-3 mt-4">Document Summary</h5>
                            <Row>
                                {clientData.documents.map((doc, idx) => (
                                    <Col md={6} key={idx}>
                                        <ListGroup>
                                            <ListGroup.Item className="border-bottom-0 rounded-0 py-3">
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <div className="d-flex align-items-center">
                                                        <img src={IconPdf} alt="pdf" width={30} className="me-2" />
                                                        <div>
                                                            <h6 className="mb-1 text-primary fw-bold">
                                                                {decodeURIComponent(doc.fileKey?.split('/').pop()) || "Document"}
                                                            </h6>
                                                            <span className="text-muted small">
                                                                {doc.type} - Updated {doc.updatedAt}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <Button
                                                            variant="link"
                                                            className="text-primary p-0"
                                                            href={doc.fileUrl}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                        >
                                                            <MdOutlineFileDownload className="text-light" size={25} />
                                                        </Button>
                                                    </div>
                                                </div>
                                            </ListGroup.Item>
                                        </ListGroup>
                                    </Col>
                                ))}
                            </Row>
                        </>
                    )}


                    {(!priorYearFileUrl && !currentYearFileUrl && !priorYearFinancialsUrl) && (
                        <Col md={12}>
                            <p className="text-muted">No documents available</p>
                        </Col>
                    )}
                </Row>
            </div>
        );
    };




    if (loading) {
        return <Loader />;
    }

    return (
        <Container fluid className="p-0 client-details">
            <Card className="px-3 py-4 mb-4" style={{ border: '1px solid #ECEEF5' }}>
                <Row>
                    <Col lg={6} className="my-auto">
                        {activeTab === "overview" ? (
                            <>
                                <h3 className="fw-bold mb-0" style={{ fontSize: '20px' }}>{clientData.name}</h3>
                                <p className="text-muted mb-0">
                                    {clientData.address1}, {clientData.city}, {clientData.stateCode} {clientData.zip}
                                </p>
                            </>
                        ) : (
                            <>
                                <h3 className="fw-bold mb-0" style={{ fontSize: '20px' }}>{clientData.name}</h3>
                                <p className="text-muted mb-0">
                                    {clientData.industry || clientData.engagements?.[0]?.type || "N/A"} | Year End: {clientData.engagements?.[0]?.endDate || "N/A"}
                                </p>

                            </>
                        )}
                    </Col>


                    <Col lg={6} className="mt-3 mt-lg-0">
                        <Row>
                            <Col className="d-flex justify-content-lg-end">
                                <Button
                                    variant="primary"
                                    size="md"
                                    className="px-4 fw-bold"
                                    onClick={handleAction}
                                    disabled={!clientData.isActive}
                                >
                                    <img src={iconEdit} alt="add" className="me-2 my-auto" />
                                    Edit Client
                                </Button>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Card>

            <Container fluid>
                <div className="client-tabs mb-4">
                    <Nav variant="tabs" className="border-bottom">
                        <Nav.Item>
                            <Nav.Link
                                className={activeTab === "overview" ? "active fw-bold" : ""}
                                onClick={() => handleTabChange("overview")}
                            >
                                Overview
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link
                                className={activeTab === "documents" ? "active fw-bold" : ""}
                                onClick={() => handleTabChange("documents")}
                            >
                                Documents
                            </Nav.Link>
                        </Nav.Item>
                    </Nav>
                </div>
            </Container>

            <Container fluid>
                <div className="tab-content">
                    {activeTab === "overview" ? renderOverviewTab() : renderDocumentsTab()}
                </div>
            </Container>

            {isModalOpen && clientData && (
                <EditClientModal
                    isOpen={isModalOpen}
                    toggle={toggleModal}
                    onToggle={handleToggle}
                    initialData={clientData} // 👈 Pass client data to the modal
                />
            )}

        </Container>
    );
}

export default ClientDetails;